<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" viewBox="0 0 48 48">
    <title>{{ title }}</title>
    <g :fill="fill">
      <circle cx="11.5" cy="36.5" r="4.5"></circle>
      <circle cx="37.5" cy="36.5" r="4.5"></circle>
      <path d="M47.447,24.105l-3.574-1.787l-1.897-8.535C41.875,13.325,41.469,13,41,13H31V8c0-0.553-0.448-1-1-1H1 C0.448,7,0,7.447,0,8v27c0,0.553,0.448,1,1,1h4.025c0.257-3.351,3.059-6,6.475-6s6.218,2.649,6.475,6H30h1.025 c0.257-3.351,3.059-6,6.475-6s6.218,2.649,6.475,6H47c0.552,0,1-0.447,1-1V25C48,24.621,47.786,24.275,47.447,24.105z"></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Truck",
  props: {
    title: {
      default: 'Livraison',
      type: String,
    },
    fill: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 14,
    },
  },
}
</script>
